export const CATEGORY_SLUG = {
  WEIGHT_LOSS: "weight-loss",
  HAIR_GROWTH: "hair-growth",
  MICRODOSING: "microdosing",
  LONGEVITY: "longevity",
  TESTOSTERONE: "testosterone-replacement-therapy",
} as const;

export const PRICE_TAG_TYPE = {
  INFORMATION: "pricing-information",
  SAVE: "price-save",
  ADMINISTRATION_METHOD: "administration-method",
  AVAILABILITY_INFORMATION: "availability-information",
  PAYMENT_TYPE: "payment-type",
  DISABLED_REASON: "disabled-reason",
} as const;

export const PRICE_TYPE = {
  RECURRING: "recurring",
  ONE_TIME: "one_time",
} as const;

export const ADMINISTRATION_FORM = {
  ORAL: "oral",
  NASAL: "nasal",
  INJECTABLE: "injectable",
} as const;

export const PRODUCT_SLUG = {
  SEMAGLUTIDE_INJECTABLE: "semaglutide",
  SEMAGLUTIDE_ORAL: "oral-semaglutide",
  TIRZEPATIDE_INJECTABLE: "tirzepatide",
  TIRZEPATIDE_ORAL: "oral-tirzepatide",
  SERMORELIN: "sermorelin",
} as const;
